import { useFeatureServices } from 'src/feature-app';

export const useIsDevStage = () => {
	const stageCustomConfig =
		useFeatureServices()['service-config-provider'].configs?.stage
			?.customConfig;

	return stageCustomConfig?.stage === 'dev';
};
